import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { FormContext, useForm } from "@ajayvikas/fluent-validation";
export const Form = React.forwardRef((props, forwardedRef) => {
    const { validator, object, mode, ...rest } = props;
    const [refFn, ctx] = useForm(props);
    React.useImperativeHandle(forwardedRef, refFn);
    return _jsx(FormContext.Provider, { value: ctx, children: _jsx("form", { ...rest }) });
});
